<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Documento</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12 card-wrapper">
          <div class="card mb-4">
            <!-- Card header -->
            <div class="card-header">
              <h3 class="mb-0">Datos del Documento</h3>
            </div>
            <div class="card-body">
              <!-- datos del documento -->
              <document-data :document="document"></document-data>
            </div>
          </div>
        </div>
        <div v-if="$can('index', 'document_comments')" class="col-md-6 col-sm-12 card-wrapper">
          <div class="card mb-4">
            <!-- Card header -->
            <div class="card-header">
              <h3 class="mb-0">Comentarios</h3>
            </div>
            <div class="card-body">
              <!-- comentarios -->
              <document-comments
                :comments="document.comments"
                :document="document"
                @addComment="addCommentToDocument"
              ></document-comments>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';

import DocumentData from './Show/DocumentData';
import DocumentComments from './Show/DocumentComments';

export default {
  name: 'DocumentsShow',
  components: {
    RouteBreadCrumb,
    DocumentData,
    DocumentComments,
  },

  data() {
    return {
      document: {},
      isDataLoaded: false,
    };
  },

  computed: {},
  created() {
    let documentId = this.$route.params.id;
    this.fetchDocument(documentId);
  },

  methods: {
    fetchComments(documentId) {
      this.$services
        .resource('document_comments')
        .get({ 'filter[document]': documentId, include: 'user' })
        .then((res) => res.data.data)
        .then((data) => (this.comments = data.comments));
    },

    fetchDocument(documentId) {
      this.$services
        .resource('documents')
        .show(documentId, { include: ['documentable', 'user.role', 'comments.user.role'] })
        .then((res) => res.data.data)
        .then((document) => {
          this.document = document;
          this.isDataLoaded = true;
        });
    },

    addCommentToDocument(comment) {
      this.$services
        .resource('document_comments')
        .create(comment)
        .then((res) => {
          this.$services
            .resource('documents')
            .show(this.document.id, { include: ['comments.user.role'] })
            .then((res) => res.data.data)
            .then((data) => (this.document.comments = data.comments));
        });
    },
  },
};
</script>
